import Content from "../services/Content";

export default {

    props: ['locale','featured'],

    data: () => { return {
        products: [],
        exclusiveTags: [],
        productsIds: []
    }},

    mounted: function() {
        this.setupFeatured();
        this.refreshProducts();
    },

    methods: {
        setupFeatured: function () {
            if (this.featured === null) {
                return false;
            }

            if (this.featured.categories !== null && this.featured.categories !== undefined) {
                this.featured.categories.forEach((item) => {
                    this.exclusiveTags.push(item);
                })
            }

            if (this.featured.products !== null && this.featured.products !== undefined) {
                this.featured.products.forEach((item) => {
                    this.productsIds.push(item.id);
                })
            }

        },
        refreshProducts: function() {
            Content.GetFeaturedProducts(this.locale, this.exclusiveTags, this.productsIds)
                .then((products) => {
                    this.products = products;
                })
        },
    }
}
